<script>
	import { auth, db } from '../../helpers/firebase.js';
	import { navigate } from 'svelte-routing';
	import { userStore } from '../../helpers/store.js';
	import {
    Row,
    Col,
    CardBody,
    Card,
    Container,
    Form,
    Label,
    Input,
    Button,
  } from "sveltestrap";
	import { Link } from 'svelte-routing';

	let email = '';
	let password = '';

	let userProfile;
	userStore.subscribe(value => {
		userProfile = value;
	});

	if (userProfile.loggedIn) {
		navigate('/');
	}
	
	// console.log(userProfile);


	// Destructuring to obtain email and password from form via Event
	const handleLoginForm = () => {
		auth.signInWithEmailAndPassword(email, password)
			.then(function (result) {
				let firebaseUser = auth.currentUser;
				db.collection('Users').doc(firebaseUser.email).get().then((userProfileDoc) => {
					if (userProfileDoc.exists) {
						userStore.set({ loggedIn: true, 
							email: userProfileDoc.data().email,
							username: userProfileDoc.data().username,
							organization: userProfileDoc.data().organization });
						// console.log(userProfileDoc.data());
						
						navigate('/challenge');
					} else {
						alert("cannot find user");
					}
				}).catch((error) => alert('login ->' + error.message))
			})
			.catch((error) => alert('login ->' + error.message));
	};
</script>

  <div class="account-pages my-5 pt-sm-5">
	<Container>
	  <Row class="justify-content-center">
		<Col md={8} lg={6} xl={5}>
		  <Card class="overflow-hidden">
			<div class="bg-primary bg-soft">
			  <Row>
				<Col class="col-12">
				  <div class="text-primary p-4">
					<h5 class="text-primary">환영합니다.</h5>
					<p>KLAID 2022 Challenge에 참가하시려면 로그인 해주세요</p>
				  </div>
				</Col>
				<!-- <Col class="col-5 align-self-end">
				  <img
					src="assets/images/klaid-title.svg"
					alt=""
					class="img-fluid"
				  />
				</Col> -->
			  </Row>
			</div>
			<CardBody class="pt-0">
			  <div class="auth-logo">
				<Link to="/" class="auth-logo-light">
				  <div class="avatar-md profile-user-wid mb-4">
					<span class="avatar-title rounded-circle bg-light">
					  <img
						src="assets/images/logo-light.svg"
						alt=""
						class="rounded-circle"
						height="34"
					  />
					</span>
				  </div>
				</Link>
				<Link to="/" class="auth-logo-dark">
				  <div class="avatar-md profile-user-wid mb-4">
					<span class="avatar-title rounded-circle bg-light">
					  <img
						src="assets/images/klaid-logo.svg"
						alt=""
						class="rounded-circle"
						height="34"
					  />
					</span>
				  </div>
				</Link>
			  </div>
			  <div class="p-2">
				<div class="form-horizontal">
				  <div class="mb-3">
					<Label for="email" class="form-label">이메일</Label>
					<Input
					  type="text"
					  class="form-control"
					  id="email"
					  placeholder="이메일을 입력해주세요"
					  bind:value={email}
					/>
				  </div>
  
				  <div class="mb-3">
					<Label class="form-label" for="password">비밀번호</Label>
					<div class="input-group auth-pass-inputgroup">
					  <Input
						type="password"
						class="form-control"
						id="password"
						placeholder="비밀번호를 입력해주세요"
						aria-label="Password"
						aria-describedby="password-addon"
						bind:value={password}
					  />
					  <Button color="light" type="button" id="password-addon"
						><i class="mdi mdi-eye-outline" /></Button
					  >
					</div>
				  </div>
  
				  <!-- <div class="form-check">
					<input
					  class="form-check-input"
					  type="checkbox"
					  id="remember-check"
					/>
					<Label class="form-check-label" for="remember-check">
					  기억하기
					</Label>
				  </div> -->
  
				  <div class="mt-3 d-grid">
					<button
						class="btn btn-primary w-md waves-effect waves-light"
						on:click={handleLoginForm}>로그인</button
					>
				  </div>
  
				  <!-- <div class="mt-4 text-center">
					<h5 class="font-size-14 mb-3">Sign in with</h5>
  
					<ul class="list-inline">
					  <li class="list-inline-item">
						<a
						  href={"#"}
						  class="social-list-item bg-primary text-white border-primary"
						>
						  <i class="mdi mdi-facebook" />
						</a>
					  </li>
					  <li class="list-inline-item">
						<a
						  href={"#"}
						  class="social-list-item bg-info text-white border-info"
						>
						  <i class="mdi mdi-twitter" />
						</a>
					  </li>
					  <li class="list-inline-item">
						<a
						  href={"#"}
						  class="social-list-item bg-danger text-white border-danger"
						>
						  <i class="mdi mdi-google" />
						</a>
					  </li>
					</ul>
				  </div> -->
  
				  <div class="mt-4 text-center">
					<Link to="auth-recoverpw" class="text-muted"
					  ><i class="mdi mdi-lock me-1" /> 비밀번호를 잊으셨나요?</Link
					>
				  </div>
				</div>
			  </div>
			</CardBody>
		  </Card>
		  <div class="mt-5 text-center">
			<p>
			  아직 등록하지 않으셨나요?{" "}
			  <Link to="register" class="fw-medium text-primary">
				{" "}
				등록하기{" "}
			  </Link>{" "}
			</p>
			<!-- <p>
			  © {new Date().getFullYear()} LAW&COMPANY. 
			</p> -->
		  </div>
		</Col>
	  </Row>
	</Container>
</div>